import { HttpHeaders } from "@angular/common/http";
import { environment } from '@environments/environment';

'use strict';

export class AuthenticationHelper {

  static applyCredentials(req) {
    let AUTHORIZE_URL: string = `${environment.base_api_uri}/uaa/oauth/token`;

    if (req.url !== AUTHORIZE_URL && this.hasAPIToken()) {
      let headers = this.getHeaders(req.headers);
      return req.clone({headers});
    } else {
      return req;
    }
  };

  static getHeaders(headers: any) {
    const api_token = this.getAPIToken();
    let bearerToken: string = api_token.token_type.charAt(0).toUpperCase() + api_token.token_type.slice(1) + ' ' + api_token.access_token;

    if (headers && headers.get('Content-Type')) {
      headers = new HttpHeaders({
        'Authorization': bearerToken,
        'Content-Type': headers.get('Content-Type')
      });
    } else {
      headers = new HttpHeaders({
        'Authorization': bearerToken
      });
    }

    return headers;
  }

  static hasAPIToken() {
    return !!this.getAPIToken();
  }

  static getAPIToken() {
    const api_token = JSON.parse(localStorage.getItem('token'));
    return api_token;
  }

}



// WEBPACK FOOTER //
// ./src/app/helpers/authentication.helper.ts